(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  /* ── Scroll reveal ──────────────────────────────────────────────────────────
     A section's static JS block is bundled into one theme file that runs ONCE
     on page load — it is not re-executed when a section re-renders. In the theme editor
     every settings change replaces this section's DOM, and the replacement
     starts at opacity 0 (html.js-reveal) with nothing left to add
     .footer--revealed — so edits looked like they did nothing until a Save
     forced a full reload.

     Two fixes: reveal immediately in design mode (no observer to wait on), and
     re-run on shopify:section:load for the re-rendered DOM. */
  function initReveal() {
    var el = document.querySelector('.footer--reveal');
    if (!el) return;
    if (window.Shopify && window.Shopify.designMode) {
      el.classList.add('footer--revealed');
      return;
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('footer--revealed');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05 }).observe(el);
    } else {
      el.classList.add('footer--revealed');
    }
  }

  initReveal();

  // Mobile accordion for menu columns
  function initAccordions() {
    var isMobile = window.innerWidth < 769;
    document.querySelectorAll('.footer__toggle-btn').forEach(function (btn) {
      var content = document.getElementById(btn.getAttribute('aria-controls'));
      if (!content) return;
      if (isMobile) {
        content.style.display = btn.getAttribute('aria-expanded') === 'true' ? '' : 'none';
      } else {
        content.style.display = '';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function bindAccordions() {
    document.querySelectorAll('.footer__toggle-btn').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        if (window.innerWidth >= 769) return;
        var content = document.getElementById(btn.getAttribute('aria-controls'));
        if (!content) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        content.style.display = open ? 'none' : '';
      });
    });
  }

  bindAccordions();

  initAccordions();
  window.addEventListener('resize', initAccordions);

  /* Re-bind everything for the DOM the editor just swapped in. Listeners are
     attached per element, so the fresh markup has none until this runs. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && !e.target.querySelector('.footer--reveal')) return;
    initReveal();
    bindAccordions();
    initAccordions();
    bindLocalization();
  });

  // Localization: auto-submit on change
  function bindLocalization() {
    ['FooterLocalizationForm', 'FooterLocaleBlock'].forEach(function (id) {
      var form = document.getElementById(id);
      if (!form) return;
      form.querySelectorAll('select').forEach(function (sel) {
        if (sel.dataset.bound) return;
        sel.dataset.bound = '1';
        sel.addEventListener('change', function () { form.submit(); });
      });
    });
  }

  bindLocalization();
}());

  } catch(e) { console.error(e); }
})();
})();
